import React from "react";
import { useNotification } from "@bbnpm/bb-ui-framework";

type NotificationOptions = {
  message: string;
  details?: string;
  [key: string]: unknown;
};

type NotificationMethod = (options: NotificationOptions) => void;

export function withFullNotificationDetails<T extends NotificationOptions>(
  options: T,
): T & { details: string } {
  const details = options.details
    ? `${options.message}\n${options.details}`
    : options.message;

  return {
    ...options,
    details,
  };
}

export function useFullNotification() {
  const notification = useNotification() as {
    addError: NotificationMethod;
    addWarning: NotificationMethod;
    addInfo: NotificationMethod;
  };

  return React.useMemo(
    () => ({
      ...notification,
      addError: (options: NotificationOptions) =>
        notification.addError(withFullNotificationDetails(options)),
      addWarning: (options: NotificationOptions) =>
        notification.addWarning(withFullNotificationDetails(options)),
      addInfo: (options: NotificationOptions) =>
        notification.addInfo(withFullNotificationDetails(options)),
    }),
    [notification],
  );
}
